module.exports = __webpack_public_path__ + "img/img1.3a0492b1.png";